export default (name, index = false) => () => import(`app/${name}${index ? '/index' : ''}.vue`)
